export default "__VITE_ASSET__960482e3__"